import _export from "../internals/export";
import _globalThis2 from "../internals/global-this";
import _arrayBuffer from "../internals/array-buffer";
import _setSpecies from "../internals/set-species";
var $ = _export;
var _globalThis = _globalThis2;
var arrayBufferModule = _arrayBuffer;
var setSpecies = _setSpecies;
var ARRAY_BUFFER = "ArrayBuffer";
var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = _globalThis[ARRAY_BUFFER];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$({
  global: true,
  constructor: true,
  forced: NativeArrayBuffer !== ArrayBuffer
}, {
  ArrayBuffer: ArrayBuffer
});
setSpecies(ARRAY_BUFFER);
export default {};